<template>
  <div>
    <b-iconstack id="p-settings"  :font-scale="controlsFontScale"
                 style="cursor:pointer; margin: 5px"
                 @click="handleSettingsClick">
      <b-icon stacked icon="circle-fill"
              variant="dark"/>
      <b-icon stacked icon="gear"
              variant="light"
              scale="0.5"
              shift-v="-0.25"
              rotate="130"
      />
      <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
    </b-iconstack>
    <b-modal
        :id="modalId"
        hide-footer
        hide-header
        centered
        size="lg"
        class="h-75 d-inline-block"
    >
      <b-row>
        <b-col>
          <close-button
              class="float-right"
              @close-button-click="handleCloseButtonClick"
            />
        </b-col>
      </b-row>
      <b-tabs
          :pills="tabs.isPills"
          :small="tabs.isSmall"
          :justified="tabs.isJustified"
          :isFill="tabs.isFill"
          :end="tabs.isEnd"
          :vertical="tabs.isVertical"
          content-class="mt-3"
          defaultActiveKey="audio"
          nav-wrapper-class="w-50"
      >
        <b-tab
            v-for="(aSection, index) in sections"
            :key="index"
            :title="aSection.title"
        >
          <template #title>
            <h5>
              <b-icon :icon="aSection.icon"
                      aria-hidden="true"/>
              {{ aSection.title }}
            </h5>
          </template>
          <component
              :is="aSection.component"
              v-bind="Object.assign({}, propsData)"
              :ref="aSection.componentName"
          >
          </component>
        </b-tab>
      </b-tabs>
      <b-tabs v-if="false"
              :pills="tabs.isPills"
              :small="tabs.isSmall"
              :justified="tabs.isJustified"
              :isFill="tabs.isFill"
              :end="tabs.isEnd"
              :vertical="tabs.isVertical"
              content-class="mt-3"
              nav-wrapper-class="w-50"
      >
        <b-tab active>
          <template #title>
            <h5>
              <b-icon icon="speaker-fill"
                      aria-hidden="true"/>
              Audio
            </h5>
          </template>
          <session-audio
              :session="session"
              :profile="profile"
              :av-resources="avResources"
          />
        </b-tab>
        <b-tab title="Video">
          <template #title>
            <h5>
              <b-icon icon="camera-video"
                      aria-hidden="true"/>
              Video
            </h5>
          </template>
          <session-video
              :session="session"
              :profile="profile"
              :av-resources="avResources"
          />
        </b-tab>
        <b-tab title="General">
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import { PreviewPublisher } from "@vonage/video-express";
import SessionAudio from "./audio";
import SessionVideo from "./video";
import CloseButton from "@/components/common/closeButton";
export default {
  name: "Sessions_Stage_Settings_Modal",
  components: {
    CloseButton,
    SessionAudio,
    SessionVideo
  },
  props: {
    modalId: {
      type: String,
      default: 'settings-modal'
    },
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    },
    avResources: {
      type: Object,
      default: () => {}
    },
    controlsFontScale: {
      type: Number,
      default: 5
    },
  },
  mounted() {},
  computed: {
    isRoomAvail(){
      return  !!(this.roomData.apiKey && this.roomData.sessionId);
    },
    isAVSetUp(){
      return !!(this.selectedAudio && this.selectedVideo);
    },
    isAuthToJoinRoom(){
      return !!this.roomData.token;
    },
    propsData() {
      return {
        profile: this.profile,
        session: this.session,
        avResources: this.avResources
      };
    }
  },
  methods: {
    handleSettingsClick(){
      this.$bvModal.show(this.modalId);
    },
    handleCloseButtonClick(){
      this.$bvModal.hide(this.modalId);
    },
    /* PREVIEWING*/
    handleStartPreview() {
      this.previewPublisher = new PreviewPublisher("previewContainer");
      let pubProps = {
        resolution: "1280x720",
        [this.selectedAudio === "" ? "publishAudio" : "audioSource"]:
            this.selectedAudio === "" ? false : this.selectedAudio,
        [this.selectedVideo === "" ? "publishVideo" : "videoSource"]:
            this.selectedVideo === "" ? false : this.selectedVideo,
        mirror: false,
        audioBitrate: 15,
        audioFallbackEnabled: true
      };
      this.previewPublisher.previewMedia({
        targetElement: "myPreviewVideo",
        publisherProperties: pubProps
      });
    },
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    }
  },
  data() {
    return {
      optsAudio: this.avResources && this.avResources.optsAudio ?  this.avResources.optsAudio : [],
      optsVideo: this.avResources && this.avResources.optsAudio ?  this.avResources.optsAudio : [],
      selectedAudio:  this.avResources && this.avResources.selectedAudio ?  this.avResources.selectedAudio :
          null,
      selectedVideo: this.avResources && this.avResources.selectedVideo ?  this.avResources.selectedVideo :
          null,
      previewPublisher: null,
      tabs: {
        isPills: true,
        isSmall: false,
        isJustified: true,
        isFill: true,
        isEnd: false,
        isVertical: true
      },
      sections : [
        {
          title: "Audio",
          id: "audio",
          icon:"speaker-fill",
          component: SessionAudio,
          componentName: "SessionAudio",
          avail: true
        },
        {
          title: "Video",
          id: "video",
          icon:"camera-video",
          component: SessionVideo,
          componentName: "SessionVideo",
          avail: true
        },
        {
          title: "General",
          id: "general",
          icon:"gear",
          component: SessionAudio,
          componentName: "SessionVideo",
          avail: true
        },
        {
          title: "Captions",
          id: "captions",
          icon:"reception3",
          component: SessionAudio,
          componentName: "SessionVideo",
          avail: true
        },
        {
          title: "Reactions",
          id: "reactions",
          icon:"emoji-wink",
          component: SessionAudio,
          componentName: "SessionVideo",
          avail: true
        },
      ],
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
